import { render, staticRenderFns } from "./secondPart.vue?vue&type=template&id=e158f870&scoped=true"
import script from "./secondPart.vue?vue&type=script&lang=js"
export * from "./secondPart.vue?vue&type=script&lang=js"
import style0 from "./secondPartCss/max.css?vue&type=style&index=0&id=e158f870&prod&scoped=true&lang=css&external"
import style1 from "./secondPartCss/middle.css?vue&type=style&index=1&id=e158f870&prod&scoped=true&lang=css&external"
import style2 from "./secondPartCss/flat.css?vue&type=style&index=2&id=e158f870&prod&scoped=true&lang=css&external"
import style3 from "./secondPartCss/min.css?vue&type=style&index=3&id=e158f870&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e158f870",
  null
  
)

export default component.exports